import { executeWithGoogleMaps } from '../../../common/googleMaps';
var bounds = null;

class MapLoader {
  constructor({ element, optionsFn }) {
    this.element = element;
    this.map = null;
    this.optionsFn = optionsFn;
    this.loaded = false;
  }

  readyEvent() {
    return new CustomEvent('ready', {
      detail: {
        element: this.element,
        map: this.map
      }
    });
  }

  ready() {
    this.loaded = true;
    this.createMap();
    this.element.dispatchEvent(this.readyEvent());
  }

  createMap() {
    bounds = new google.maps.LatLngBounds();
    this.map = new google.maps.Map(this.element, {
      ...this.optionsFn()
    });
  }

  load() {
    executeWithGoogleMaps(() => this.ready());
  }

  on(event, callback) {
    this.element.addEventListener(event, callback);

    if (event === 'ready' && this.loaded) callback(this.readyEvent());
  }

  off(event, callback) {
    this.element.removeEventListener(event, callback);
  }

  getBounds() {
    return bounds;
  }
}

export default MapLoader;
export { bounds };
